import React from 'react'
import LoginRegister from '../LoginRegister/LoginRegister'
import UMassDDLogo from '../UMassDDLogo/UMassDDLogo'

const LoginPage = () => {
  return (
    <div>
        <UMassDDLogo/>
        <LoginRegister/>
    </div>
  )
}

export default LoginPage